import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  IconButton,
  Tooltip,
} from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { Navigation, MobileMenuButton } from './Navigation';
import { ThemeSwitcher } from './ThemeSwitcher';
import { UserProfileMenu } from './UserProfileMenu';
import { HelpDrawer } from './help/HelpDrawer';
import { SimulationBanner } from './SimulationBanner';


interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Sticky header: simulation banner + AppBar + Navigation */}
      <Box sx={{ position: 'sticky', top: 0, zIndex: 1100 }}>
        {/* Renders nothing unless the backend is running the stub provider. */}
        <SimulationBanner />
        <AppBar position="static" elevation={0}>
          <Toolbar>
            <MobileMenuButton onClick={handleDrawerToggle} />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1 }}>
              <img src="/img/moh-logo.webp" alt="MOH Logo" style={{ height: 32, borderRadius: '50%' }} />
              <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                SMS Reminder System
              </Typography>
            </Box>

            <Tooltip title="Training manual">
              <IconButton
                onClick={() => setHelpOpen(true)}
                color="inherit"
                aria-label="Open the training manual"
              >
                <HelpOutline />
              </IconButton>
            </Tooltip>
            <ThemeSwitcher />
            <UserProfileMenu />
          </Toolbar>
        </AppBar>

        {/* Navigation - Desktop tabs or Mobile drawer */}
        <Navigation mobileOpen={mobileOpen} onMobileClose={handleDrawerToggle} />
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundColor: 'background.default',
          minHeight: 'calc(100vh - 64px)',
        }}
      >
        <Container maxWidth="xl" sx={{ py: 3 }}>
          {children}
        </Container>
      </Box>

      <HelpDrawer open={helpOpen} onClose={() => setHelpOpen(false)} />
    </Box>
  );
};
